/**
 * Natywne powiadomienie przegladarki (Notification API) przy nowej wiadomosci/powiadomieniu,
 * gdy karta jest w tle. Wymaga zgody - prosimy o nia jednorazowo, subtelnie, przy pierwszym
 * otwarciu widgetu (requestPermissionOnce()), nie wymuszamy jej przy starcie aplikacji.
 */

const ASKED_KEY = 'chat_notify_permission_asked';

export function isNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function requestPermissionOnce(): void {
  if (!isNotificationSupported() || Notification.permission !== 'default') {
    return;
  }

  if (sessionStorage.getItem(ASKED_KEY)) {
    return;
  }

  sessionStorage.setItem(ASKED_KEY, '1');
  Notification.requestPermission().catch(() => undefined);
}

export function notify(title: string, body: string): void {
  if (!isNotificationSupported() || Notification.permission !== 'granted') {
    return;
  }

  // Tylko gdy karta jest w tle - w otwartym, aktywnym oknie user i tak widzi wiadomosc na biezaco.
  if (document.visibilityState === 'visible') {
    return;
  }

  try {
    new Notification(title, { body, icon: 'favicon.ico' });
  } catch {
    // Niektore przegladarki (np. w trybie prywatnym) odmawiaja mimo "granted" - pomijamy cicho.
  }
}
